import React from "react";

type Props = {
  heading: string;
  subHeading?: string;
  headingColor?: string;
  subHeadingColor?: string;
  textAlign?: string;
  spacing?: string;
  maxWidth?: boolean;
};

export default function HomeSectionHeading({
  heading,
  subHeading,
  headingColor = "text-primaryBlack",
  subHeadingColor = "text-[#404040]",
  textAlign = "text-center",
  maxWidth = false,
  spacing = "mb-6 sm:mb-8",
}: Props) {
  return (
    <>
      <h2
        className={`text-2xl sm:text-3xl sm:leading-9 2md:text-4xl 2md:leading-10 2lg:text-5xl leading-1.3 2lg:leading-1.2 tracking-[-5%] font-bold ${textAlign} ${headingColor} ${!subHeading ? spacing : "mb-3 md:mb-4"}`}
        dangerouslySetInnerHTML={{ __html: heading }}
      />

      {subHeading && (
        <p
          className={`${maxWidth ? "w-11/12 mx-auto" : ""} ${subHeadingColor} text-sm sm:text-base leading-1.3! ${textAlign} ${spacing}`}
          dangerouslySetInnerHTML={{ __html: subHeading }}
        />
      )}
    </>
  );
}
